import { useAppSelector } from 'store/hooks';

import type { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';
import { DashboardNavigation } from 'components/layout/navigation/dashboardNavigation';
import { ContactBlock } from 'components/layout/navigation/contactBlock';
import { DashboardTitle } from 'components/layout/header/dashboardTitle';
import { Policy } from './policy';

import './dashboard.scss';

export const Dashboard = ({ selectedPolicy, setShow }: HpChildComponentProps): JSX.Element => {
  const policies = useAppSelector((state) => state.customerData.policies);

  return (
    <>
      <DashboardTitle title="WELCOME BACK" selectedPolicy={selectedPolicy} />
      <div className="dashboard-container">
        <Policy
          selectedPolicy={selectedPolicy}
          onClickSelect={setShow}
          isMultiplePolicies={policies ? policies.length > 1 : false}
        />
        <DashboardNavigation />
        <ContactBlock />
      </div>
    </>
  );
};
